import { create } from 'zustand'
import { queryClient } from '@/lib/queryClient'

// ── Types ──────────────────────────────────────────────────────────────────────

export interface ActingAsUser {
  id: string
  name: string
  email?: string | null
}

interface DelegationState {
  /** The user ID being acted as, or null if not in delegation mode. */
  actingAsUserId: string | null
  /** Display info for the banner. */
  actingAsUser: ActingAsUser | null

  /** Start acting as another user (Tier 1 — read-only, no approval required for admin). */
  startActingAs: (user: ActingAsUser) => void
  /** Stop acting as another user and return to own identity. */
  stopActingAs: () => void
}

// ── Store ──────────────────────────────────────────────────────────────────────
// Intentionally NOT persisted to localStorage — delegation state must not
// survive a page reload (security requirement: avoids stale impersonation).

export const useDelegationStore = create<DelegationState>((set) => ({
  actingAsUserId: null,
  actingAsUser: null,

  startActingAs: (user) => {
    set({ actingAsUserId: user.id, actingAsUser: user })
    // Clear React Query cache synchronously so the next fetch uses X-Act-As header
    queryClient.clear()
  },

  stopActingAs: () => {
    set({ actingAsUserId: null, actingAsUser: null })
    // Clear cache synchronously so navigation lands on fresh data (no stale delegated data)
    queryClient.clear()
  },
}))
